// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Models/OrcModels.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { PagingInfo } from "./SystemModels";

export const protobufPackage = "daisi.protos.v1";

export enum OrcStatus {
  OrcStatusOffline = 0,
  OrcStatusOnline = 1,
  OrcStatusMaintenance = 2,
  OrcStatusArchived = 3,
  UNRECOGNIZED = -1,
}

export function orcStatusFromJSON(object: any): OrcStatus {
  switch (object) {
    case 0:
    case "OrcStatusOffline":
      return OrcStatus.OrcStatusOffline;
    case 1:
    case "OrcStatusOnline":
      return OrcStatus.OrcStatusOnline;
    case 2:
    case "OrcStatusMaintenance":
      return OrcStatus.OrcStatusMaintenance;
    case 3:
    case "OrcStatusArchived":
      return OrcStatus.OrcStatusArchived;
    case -1:
    case "UNRECOGNIZED":
    default:
      return OrcStatus.UNRECOGNIZED;
  }
}

export function orcStatusToJSON(object: OrcStatus): string {
  switch (object) {
    case OrcStatus.OrcStatusOffline:
      return "OrcStatusOffline";
    case OrcStatus.OrcStatusOnline:
      return "OrcStatusOnline";
    case OrcStatus.OrcStatusMaintenance:
      return "OrcStatusMaintenance";
    case OrcStatus.OrcStatusArchived:
      return "OrcStatusArchived";
    case OrcStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface GetOrcsRequest {
  Paging?: PagingInfo | undefined;
  OrcId?: string | undefined;
  NetworkId?: string | undefined;
}

export interface GetOrcsResponse {
  Orcs: Orchestrator[];
  TotalCount: number;
}

export interface UpdateOrcRequest {
  Orc?: Orchestrator | undefined;
}

export interface UpdateOrcResponse {
  Success: boolean;
  Message?: string | undefined;
}

export interface ArchiveOrcRequest {
  OrcId: string;
}

export interface ArchiveOrcResponse {
  Success: boolean;
  Message?: string | undefined;
}

export interface CreateOrcRequest {
  Orc?: Orchestrator | undefined;
}

export interface CreateOrcResponse {
  Orc?: Orchestrator | undefined;
  Message?: string | undefined;
}

export interface Orchestrator {
  Id: string;
  Name: string;
  Networks: OrcNetwork[];
  Domain: string;
  Port: number;
  RequiresSSL: boolean;
  OpenConnectionCount: number;
  DateStart?: Date | undefined;
  DateStop?: Date | undefined;
  Version: string;
  Status: OrcStatus;
  AccountId: string;
  AccountName: string;
}

export interface OrcNetwork {
  Id: string;
  Name: string;
  IsPublic: boolean;
}

function createBaseGetOrcsRequest(): GetOrcsRequest {
  return { Paging: undefined, OrcId: undefined, NetworkId: undefined };
}

export const GetOrcsRequest: MessageFns<GetOrcsRequest> = {
  encode(message: GetOrcsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Paging !== undefined) {
      PagingInfo.encode(message.Paging, writer.uint32(10).fork()).join();
    }
    if (message.OrcId !== undefined) {
      writer.uint32(18).string(message.OrcId);
    }
    if (message.NetworkId !== undefined) {
      writer.uint32(26).string(message.NetworkId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOrcsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOrcsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Paging = PagingInfo.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.OrcId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.NetworkId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOrcsRequest {
    return {
      Paging: isSet(object.Paging) ? PagingInfo.fromJSON(object.Paging) : undefined,
      OrcId: isSet(object.OrcId) ? globalThis.String(object.OrcId) : undefined,
      NetworkId: isSet(object.NetworkId) ? globalThis.String(object.NetworkId) : undefined,
    };
  },

  toJSON(message: GetOrcsRequest): unknown {
    const obj: any = {};
    if (message.Paging !== undefined) {
      obj.Paging = PagingInfo.toJSON(message.Paging);
    }
    if (message.OrcId !== undefined) {
      obj.OrcId = message.OrcId;
    }
    if (message.NetworkId !== undefined) {
      obj.NetworkId = message.NetworkId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOrcsRequest>, I>>(base?: I): GetOrcsRequest {
    return GetOrcsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOrcsRequest>, I>>(object: I): GetOrcsRequest {
    const message = createBaseGetOrcsRequest();
    message.Paging = (object.Paging !== undefined && object.Paging !== null)
      ? PagingInfo.fromPartial(object.Paging)
      : undefined;
    message.OrcId = object.OrcId ?? undefined;
    message.NetworkId = object.NetworkId ?? undefined;
    return message;
  },
};

function createBaseGetOrcsResponse(): GetOrcsResponse {
  return { Orcs: [], TotalCount: 0 };
}

export const GetOrcsResponse: MessageFns<GetOrcsResponse> = {
  encode(message: GetOrcsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Orcs) {
      Orchestrator.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.TotalCount !== 0) {
      writer.uint32(16).int32(message.TotalCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOrcsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOrcsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Orcs.push(Orchestrator.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.TotalCount = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOrcsResponse {
    return {
      Orcs: globalThis.Array.isArray(object?.Orcs) ? object.Orcs.map((e: any) => Orchestrator.fromJSON(e)) : [],
      TotalCount: isSet(object.TotalCount) ? globalThis.Number(object.TotalCount) : 0,
    };
  },

  toJSON(message: GetOrcsResponse): unknown {
    const obj: any = {};
    if (message.Orcs?.length) {
      obj.Orcs = message.Orcs.map((e) => Orchestrator.toJSON(e));
    }
    if (message.TotalCount !== 0) {
      obj.TotalCount = Math.round(message.TotalCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOrcsResponse>, I>>(base?: I): GetOrcsResponse {
    return GetOrcsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOrcsResponse>, I>>(object: I): GetOrcsResponse {
    const message = createBaseGetOrcsResponse();
    message.Orcs = object.Orcs?.map((e) => Orchestrator.fromPartial(e)) || [];
    message.TotalCount = object.TotalCount ?? 0;
    return message;
  },
};

function createBaseUpdateOrcRequest(): UpdateOrcRequest {
  return { Orc: undefined };
}

export const UpdateOrcRequest: MessageFns<UpdateOrcRequest> = {
  encode(message: UpdateOrcRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Orc !== undefined) {
      Orchestrator.encode(message.Orc, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateOrcRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateOrcRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Orc = Orchestrator.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateOrcRequest {
    return { Orc: isSet(object.Orc) ? Orchestrator.fromJSON(object.Orc) : undefined };
  },

  toJSON(message: UpdateOrcRequest): unknown {
    const obj: any = {};
    if (message.Orc !== undefined) {
      obj.Orc = Orchestrator.toJSON(message.Orc);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateOrcRequest>, I>>(base?: I): UpdateOrcRequest {
    return UpdateOrcRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateOrcRequest>, I>>(object: I): UpdateOrcRequest {
    const message = createBaseUpdateOrcRequest();
    message.Orc = (object.Orc !== undefined && object.Orc !== null) ? Orchestrator.fromPartial(object.Orc) : undefined;
    return message;
  },
};

function createBaseUpdateOrcResponse(): UpdateOrcResponse {
  return { Success: false, Message: undefined };
}

export const UpdateOrcResponse: MessageFns<UpdateOrcResponse> = {
  encode(message: UpdateOrcResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.Message !== undefined) {
      writer.uint32(18).string(message.Message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateOrcResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateOrcResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateOrcResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      Message: isSet(object.Message) ? globalThis.String(object.Message) : undefined,
    };
  },

  toJSON(message: UpdateOrcResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.Message !== undefined) {
      obj.Message = message.Message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateOrcResponse>, I>>(base?: I): UpdateOrcResponse {
    return UpdateOrcResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateOrcResponse>, I>>(object: I): UpdateOrcResponse {
    const message = createBaseUpdateOrcResponse();
    message.Success = object.Success ?? false;
    message.Message = object.Message ?? undefined;
    return message;
  },
};

function createBaseArchiveOrcRequest(): ArchiveOrcRequest {
  return { OrcId: "" };
}

export const ArchiveOrcRequest: MessageFns<ArchiveOrcRequest> = {
  encode(message: ArchiveOrcRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.OrcId !== "") {
      writer.uint32(10).string(message.OrcId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArchiveOrcRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArchiveOrcRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.OrcId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ArchiveOrcRequest {
    return { OrcId: isSet(object.OrcId) ? globalThis.String(object.OrcId) : "" };
  },

  toJSON(message: ArchiveOrcRequest): unknown {
    const obj: any = {};
    if (message.OrcId !== "") {
      obj.OrcId = message.OrcId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ArchiveOrcRequest>, I>>(base?: I): ArchiveOrcRequest {
    return ArchiveOrcRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArchiveOrcRequest>, I>>(object: I): ArchiveOrcRequest {
    const message = createBaseArchiveOrcRequest();
    message.OrcId = object.OrcId ?? "";
    return message;
  },
};

function createBaseArchiveOrcResponse(): ArchiveOrcResponse {
  return { Success: false, Message: undefined };
}

export const ArchiveOrcResponse: MessageFns<ArchiveOrcResponse> = {
  encode(message: ArchiveOrcResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.Message !== undefined) {
      writer.uint32(18).string(message.Message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArchiveOrcResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArchiveOrcResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ArchiveOrcResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      Message: isSet(object.Message) ? globalThis.String(object.Message) : undefined,
    };
  },

  toJSON(message: ArchiveOrcResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.Message !== undefined) {
      obj.Message = message.Message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ArchiveOrcResponse>, I>>(base?: I): ArchiveOrcResponse {
    return ArchiveOrcResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArchiveOrcResponse>, I>>(object: I): ArchiveOrcResponse {
    const message = createBaseArchiveOrcResponse();
    message.Success = object.Success ?? false;
    message.Message = object.Message ?? undefined;
    return message;
  },
};

function createBaseCreateOrcRequest(): CreateOrcRequest {
  return { Orc: undefined };
}

export const CreateOrcRequest: MessageFns<CreateOrcRequest> = {
  encode(message: CreateOrcRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Orc !== undefined) {
      Orchestrator.encode(message.Orc, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateOrcRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateOrcRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Orc = Orchestrator.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateOrcRequest {
    return { Orc: isSet(object.Orc) ? Orchestrator.fromJSON(object.Orc) : undefined };
  },

  toJSON(message: CreateOrcRequest): unknown {
    const obj: any = {};
    if (message.Orc !== undefined) {
      obj.Orc = Orchestrator.toJSON(message.Orc);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateOrcRequest>, I>>(base?: I): CreateOrcRequest {
    return CreateOrcRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateOrcRequest>, I>>(object: I): CreateOrcRequest {
    const message = createBaseCreateOrcRequest();
    message.Orc = (object.Orc !== undefined && object.Orc !== null) ? Orchestrator.fromPartial(object.Orc) : undefined;
    return message;
  },
};

function createBaseCreateOrcResponse(): CreateOrcResponse {
  return { Orc: undefined, Message: undefined };
}

export const CreateOrcResponse: MessageFns<CreateOrcResponse> = {
  encode(message: CreateOrcResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Orc !== undefined) {
      Orchestrator.encode(message.Orc, writer.uint32(10).fork()).join();
    }
    if (message.Message !== undefined) {
      writer.uint32(18).string(message.Message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateOrcResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateOrcResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Orc = Orchestrator.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateOrcResponse {
    return {
      Orc: isSet(object.Orc) ? Orchestrator.fromJSON(object.Orc) : undefined,
      Message: isSet(object.Message) ? globalThis.String(object.Message) : undefined,
    };
  },

  toJSON(message: CreateOrcResponse): unknown {
    const obj: any = {};
    if (message.Orc !== undefined) {
      obj.Orc = Orchestrator.toJSON(message.Orc);
    }
    if (message.Message !== undefined) {
      obj.Message = message.Message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateOrcResponse>, I>>(base?: I): CreateOrcResponse {
    return CreateOrcResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateOrcResponse>, I>>(object: I): CreateOrcResponse {
    const message = createBaseCreateOrcResponse();
    message.Orc = (object.Orc !== undefined && object.Orc !== null) ? Orchestrator.fromPartial(object.Orc) : undefined;
    message.Message = object.Message ?? undefined;
    return message;
  },
};

function createBaseOrchestrator(): Orchestrator {
  return {
    Id: "",
    Name: "",
    Networks: [],
    Domain: "",
    Port: 0,
    RequiresSSL: false,
    OpenConnectionCount: 0,
    DateStart: undefined,
    DateStop: undefined,
    Version: "",
    Status: 0,
    AccountId: "",
    AccountName: "",
  };
}

export const Orchestrator: MessageFns<Orchestrator> = {
  encode(message: Orchestrator, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    if (message.Name !== "") {
      writer.uint32(18).string(message.Name);
    }
    for (const v of message.Networks) {
      OrcNetwork.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.Domain !== "") {
      writer.uint32(34).string(message.Domain);
    }
    if (message.Port !== 0) {
      writer.uint32(40).int32(message.Port);
    }
    if (message.RequiresSSL !== false) {
      writer.uint32(48).bool(message.RequiresSSL);
    }
    if (message.OpenConnectionCount !== 0) {
      writer.uint32(56).int32(message.OpenConnectionCount);
    }
    if (message.DateStart !== undefined) {
      Timestamp.encode(toTimestamp(message.DateStart), writer.uint32(66).fork()).join();
    }
    if (message.DateStop !== undefined) {
      Timestamp.encode(toTimestamp(message.DateStop), writer.uint32(74).fork()).join();
    }
    if (message.Version !== "") {
      writer.uint32(82).string(message.Version);
    }
    if (message.Status !== 0) {
      writer.uint32(88).int32(message.Status);
    }
    if (message.AccountId !== "") {
      writer.uint32(98).string(message.AccountId);
    }
    if (message.AccountName !== "") {
      writer.uint32(106).string(message.AccountName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Orchestrator {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrchestrator();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.Networks.push(OrcNetwork.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.Domain = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.Port = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.RequiresSSL = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.OpenConnectionCount = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.DateStart = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.DateStop = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.Version = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.Status = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.AccountName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Orchestrator {
    return {
      Id: isSet(object.Id) ? globalThis.String(object.Id) : "",
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
      Networks: globalThis.Array.isArray(object?.Networks)
        ? object.Networks.map((e: any) => OrcNetwork.fromJSON(e))
        : [],
      Domain: isSet(object.Domain) ? globalThis.String(object.Domain) : "",
      Port: isSet(object.Port) ? globalThis.Number(object.Port) : 0,
      RequiresSSL: isSet(object.RequiresSSL) ? globalThis.Boolean(object.RequiresSSL) : false,
      OpenConnectionCount: isSet(object.OpenConnectionCount) ? globalThis.Number(object.OpenConnectionCount) : 0,
      DateStart: isSet(object.DateStart) ? fromJsonTimestamp(object.DateStart) : undefined,
      DateStop: isSet(object.DateStop) ? fromJsonTimestamp(object.DateStop) : undefined,
      Version: isSet(object.Version) ? globalThis.String(object.Version) : "",
      Status: isSet(object.Status) ? orcStatusFromJSON(object.Status) : 0,
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      AccountName: isSet(object.AccountName) ? globalThis.String(object.AccountName) : "",
    };
  },

  toJSON(message: Orchestrator): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    if (message.Networks?.length) {
      obj.Networks = message.Networks.map((e) => OrcNetwork.toJSON(e));
    }
    if (message.Domain !== "") {
      obj.Domain = message.Domain;
    }
    if (message.Port !== 0) {
      obj.Port = Math.round(message.Port);
    }
    if (message.RequiresSSL !== false) {
      obj.RequiresSSL = message.RequiresSSL;
    }
    if (message.OpenConnectionCount !== 0) {
      obj.OpenConnectionCount = Math.round(message.OpenConnectionCount);
    }
    if (message.DateStart !== undefined) {
      obj.DateStart = message.DateStart.toISOString();
    }
    if (message.DateStop !== undefined) {
      obj.DateStop = message.DateStop.toISOString();
    }
    if (message.Version !== "") {
      obj.Version = message.Version;
    }
    if (message.Status !== 0) {
      obj.Status = orcStatusToJSON(message.Status);
    }
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (message.AccountName !== "") {
      obj.AccountName = message.AccountName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Orchestrator>, I>>(base?: I): Orchestrator {
    return Orchestrator.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Orchestrator>, I>>(object: I): Orchestrator {
    const message = createBaseOrchestrator();
    message.Id = object.Id ?? "";
    message.Name = object.Name ?? "";
    message.Networks = object.Networks?.map((e) => OrcNetwork.fromPartial(e)) || [];
    message.Domain = object.Domain ?? "";
    message.Port = object.Port ?? 0;
    message.RequiresSSL = object.RequiresSSL ?? false;
    message.OpenConnectionCount = object.OpenConnectionCount ?? 0;
    message.DateStart = object.DateStart ?? undefined;
    message.DateStop = object.DateStop ?? undefined;
    message.Version = object.Version ?? "";
    message.Status = object.Status ?? 0;
    message.AccountId = object.AccountId ?? "";
    message.AccountName = object.AccountName ?? "";
    return message;
  },
};

function createBaseOrcNetwork(): OrcNetwork {
  return { Id: "", Name: "", IsPublic: false };
}

export const OrcNetwork: MessageFns<OrcNetwork> = {
  encode(message: OrcNetwork, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    if (message.Name !== "") {
      writer.uint32(18).string(message.Name);
    }
    if (message.IsPublic !== false) {
      writer.uint32(24).bool(message.IsPublic);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrcNetwork {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrcNetwork();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.IsPublic = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrcNetwork {
    return {
      Id: isSet(object.Id) ? globalThis.String(object.Id) : "",
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
      IsPublic: isSet(object.IsPublic) ? globalThis.Boolean(object.IsPublic) : false,
    };
  },

  toJSON(message: OrcNetwork): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    if (message.IsPublic !== false) {
      obj.IsPublic = message.IsPublic;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrcNetwork>, I>>(base?: I): OrcNetwork {
    return OrcNetwork.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrcNetwork>, I>>(object: I): OrcNetwork {
    const message = createBaseOrcNetwork();
    message.Id = object.Id ?? "";
    message.Name = object.Name ?? "";
    message.IsPublic = object.IsPublic ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
